class ScreeningTestDefinition {
    public Id: number;
    public Name: string;
    public VocabularyResourceKey: string;

    public TestTerms: { [id: string]: string };
    public ThemeTerms: { [id: string]: string };

    constructor(fields: Partial<ScreeningTestDefinition> = null) {
        if (fields) {
            (<any>Object).assign(this, fields);
        }
    }

    public getTranslatedTestDefinitionName(): string {
        const themeName = this.getThemeName(sessionStore.userLanguageCode);
        const testName = this.getTestName(sessionStore.userLanguageCode);

        if (!themeName)
            return cacheStore.GetString(this.VocabularyResourceKey);

        return testName
            ? `${themeName} - ${testName}`
            : themeName;
    }

    private getThemeName(lang: string): string {
        const locale = this.getLocale(lang);
        return this.ThemeTerms && this.ThemeTerms[locale]
            ? this.ThemeTerms[locale]
            : "";
    }

    private getTestName(lang: string): string {
        const locale = this.getLocale(lang);
        return this.TestTerms && this.TestTerms[locale]
            ? this.TestTerms[locale]
            : "";
    }

    private getLocale(lang: string): string {
        return lang === "es-MX" || lang == "esMX" ? "es" : lang;
    }
}

export { ScreeningTestDefinition };
